'use strict';

var _ = require('lodash');
var FaresSurchargeUploadImportModalDirective = function FaresSurchargeUploadImportModalDirective($timeout) {
  return {
    restrict: 'E',
    replace: true,
    template: require('../templates/fares-surcharge-upload-import-modal.html'),
    controller: 'FaresSurchargeUploadImportModalController',
    link: function link(scope, element) {
      element.find('.import-help-icon').popover();
      scope.$on('fares-surcharge-upload-grid:showImportModal', function () {
        element.modal('show');
      });
      scope.$on('fares-surcharge-upload:errorLogClose', function () {
        scope.hideErrorLog();
      });
      function resetInput(elem) {
        elem.wrap('<form>').closest('form').get(0).reset();
        elem.unwrap();
      }
      element.on('hidden.bs.modal', function () {
        resetInput(element.find('#import-browse-button'));
      });
      element.find('#import-browse-button').bind('change', function (event) {
        $timeout(function () {
          var file = _.first(event.target.files);
          var fileName = _.isUndefined(file) ? '' : file.name;
          if (_.endsWith(fileName, '.csv')) {
            scope.chosenFileName = fileName;
            scope.chosenFile = file;
          } else {
            scope.chosenFileName = '';
            scope.chosenFile = null;
          }
        }, 0);
      });
    }
  };
};
FaresSurchargeUploadImportModalDirective.$inject = ['$timeout'];
module.exports = FaresSurchargeUploadImportModalDirective;